angular.module('bizmetryApp').service('UserProfileService', ['$http', 'CONFIG', function ($http, CONFIG) {

  const BASE_URL = CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account';

  // 📋 Get the current user's full profile (user + account combined)
  this.getUserProfile = function () {
    return $http.get(BASE_URL + '/user-profile');
  };

  // 🏢 Get fresh account data by accountId
  this.getAccount = function (accountId) {
    return $http.get(BASE_URL + '/account/' + accountId);
  };

  // ✏️ Patch the current user's own profile (firstName, lastName, user2FANumber, password)
  // Only non-null fields are sent — omitted fields are not changed on the backend
  this.patchUserProfile = function (data) {
    var payload = {};

    if (data.firstName     != null) payload.firstName     = data.firstName;
    if (data.lastName      != null) payload.lastName      = data.lastName;
    if (data.user2FANumber != null) payload.user2FANumber = data.user2FANumber;
    if (data.password      != null) payload.password      = data.password;

    return $http.patch(BASE_URL + '/user-profile', payload);
  };

}]);
